import { browser } from '$app/environment';
import { setContext } from 'svelte';
import { writable } from 'svelte/store';
import { formatEther, formatUnits } from 'viem';
import { disconnect, getBalance, reconnect, watchAccount } from 'wagmi/actions';
import { AppKitInitializer } from './appKitInitializer';
import { ContextStateSymbol } from './context';
export class Web3Manager {
    config = writable();
    walletModal = writable();
    wallet = writable(null);
    unwatchAccount = null;
    loading = writable(false);
    constructor() { }
    init(initData) {
        setContext(ContextStateSymbol, {
            walletModal: this.walletModal,
            config: this.config,
            wallet: this.wallet,
            loading: this.loading,
        });
        if (!browser) {
            return;
        }
        this.loading.set(true);
        const { config, modal } = new AppKitInitializer(initData);
        this.config.set(config);
        reconnect(config);
        this.walletModal.set(modal);
        this.setupAccountListener(config, initData.token);
        this.loading.set(false);
    }
    destroy() {
        if (this.unwatchAccount) {
            this.unwatchAccount();
            this.unwatchAccount = null;
        }
    }
    async setWallet(config, address, token) {
        try {
            const [{ value: ethWei }, { value: usdcWei }] = await Promise.all([
                getBalance(config, { address }),
                getBalance(config, { address, token }),
            ]);
            const eth = formatEther(ethWei);
            const usdc = formatUnits(usdcWei, 6);
            if (this.wallet)
                this.wallet.set({ address, balance: { eth, usdc } });
        }
        catch (error) {
            console.error(error);
        }
    }
    async updateWalletOnAccountChange(account, tokenAddress, config) {
        if (account.isConnected && account.address) {
            await this.setWallet(config, account.address, tokenAddress);
            this.loading.set(false);
        }
        else if (account.isDisconnected) {
            await disconnect(config);
            this.loading.set(false);
            this.wallet.set(null);
        }
    }
    setupAccountListener(config, tokenAddress) {
        this.unwatchAccount = watchAccount(config, {
            onChange: (account) => {
                this.updateWalletOnAccountChange(account, tokenAddress, config);
            },
        });
    }
}
